import React from 'react';
import authRoles from 'app/auth/authRoles';
import PaymentManagement from './PaymentManagement';
import CompanyDetail from './schoolRoyalties/CompanyDetail';
import SchoolRoyalties from './schoolRoyalties/SchoolRoyalties';
import RoyaltyInfo from './schoolRoyalties/RoyaltyInfo';

const PaymentManagementConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/PaymentManagement',
			element: (
				<React.Suspense fallback={<>...</>}>
					<PaymentManagement />
				</React.Suspense>
			),
		},
		// {
		// 	path: '/CompanyDetail/:id',
		// 	component: CompanyDetail
		// },
		// {
		// 	path: '/SchoolRoyalties',
		// 	component: SchoolRoyalties
		// }
		{
			path: '/company-royalty/',
			element: (
				<React.Suspense fallback={<>...</>}>
					<RoyaltyInfo />
				</React.Suspense>
			),
		},
		{
			path: '/company-royalty/:id',
			element: (
				<React.Suspense fallback={<>...</>}>
					<RoyaltyInfo />
				</React.Suspense>
			),
		},
	],
	auth: authRoles.productOwner,
};

export default PaymentManagementConfig;
